type Props = {
  firstName: string | null
  lastName: string | null
  fullName?: string | null
}

export default function Prescriber({ firstName, lastName, fullName }: Props) {
  const parsedFullName = fullName || [firstName, lastName].filter(Boolean).join(' ')
  const [firstWord, secondWord] = parsedFullName.split(' ')
  const initials = `${firstWord?.[0] ?? '?'}${secondWord?.[0] ?? '?'}`.toUpperCase()

  if (!parsedFullName) {
    return <p className='text-base  leading-[27.2px] font-medium text-[#1D1D1D]'>{'N/A'}</p>
  }

  return (
    <div className='flex items-center gap-2'>
      <div className='grid place-content-center w-12 h-12 rounded-2xl bg-[#EBEFFA] text-custom-blue-600 font-medium text-sm'>
        {initials}
      </div>
      <div>
        <p className='text-base  leading-[27.2px] font-medium text-[#1D1D1D]'>{parsedFullName}</p>
      </div>
    </div>
  )
}
